import { hasValue } from '../helpers'
import { getApiClient } from './apiService'
import config from '../config/env'

const getCompanyTransferRequests = async () => {
  try {
    const url = `/company-transfer-requests`

    const response = await getApiClient().get(url)
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getAllCompanies error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const sendCompanyTransferRequest = async data => {
  try {
    const response = await getApiClient().post(
      '/company-transfer-requests',
      data,
    )
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('sendCompanyTransferRequest error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const replaceUserAccount = async ({
  transferRequestId,
  oldUserId,
  newUserId,
}) => {
  const data = {
    old_user_id: oldUserId,
    new_user_id: newUserId,
    transfer_request_id: transferRequestId,
  }

  try {
    const response = await getApiClient().post(
      '/conversations/admin/replace-participant',
      data,
    )
    if ((response.status === 200 || response.status === 201) && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('replaceUserAccount error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const rejectCompanyTransfer = async ({ transferRequestId }) => {
  const data = {
    id: transferRequestId,
  }

  try {
    const response = await getApiClient().post(
      '/reject-company-transfer-request',
      data,
    )
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('rejectCompanyTransfer error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const companyTransferService = {
  getCompanyTransferRequests,
  sendCompanyTransferRequest,
  replaceUserAccount,
  rejectCompanyTransfer,
}
